import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";
import { Constraint } from "@planzone/dto";

function ConstraintTypeSelect({ type, select }: Props) {
  const { t } = useTranslation();

  return (
    <SelectList listClassName={styles.listRoot}>
      {({ isOpen, select: s }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            <p className={styles.name}>
              {t(`constraintTypeForm.constraintTypes.${type}`)}
            </p>
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {["EXACTLY", "AT_MOST", "AT_LEAST"].map((item) => (
              <div
                key={item}
                className={classNames(styles.type, {
                  [styles.selected]: item === type,
                })}
                onClick={() => s(select(item as Constraint["constraintType"]))}
              >
                <p className={styles.name}>
                  {t(`constraintTypeForm.constraintTypes.${item}`)}
                </p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ConstraintTypeSelect };
